<template>
  <div class="dongle-list px">
    <div class="dongle" :class="{ unlinked: !dongle }">
      <i class="iconfont icondongle" /> AM Sniper2.4
      {{ dongle ? $t("loader.linked") : $t("loader.unlinked") }}
    </div>
    <img class="logo" :src="images.logo_white" />
    <div class="version" @click="onDongleUpdate">
      <span>
        {{ $t("loader.firmwareVersion") }}
        <img
          class="new"
          :src="images.icon_new"
          v-show="dongle && !dongle.isLatestVersion"
        />
      </span>
      <span class="code" v-if="dongle">
        {{ dongle.version }} <i class="iconfont iconarrow-right" />
      </span>
    </div>
    <md-field class="device">
      <label for="device">
        {{
          dongle && dongle.deviceList
            ? $t("loader.selectDevice")
            : $t("loader.undetected")
        }}
      </label>
      <md-select
        name="device"
        id="device"
        :disabled="!(dongle && dongle.deviceList.length)"
        @md-selected="onDeviceSelect"
      >
        <template v-if="dongle && dongle.deviceList">
          <md-option
            v-for="device in dongle.deviceList"
            :value="device.port"
            :key="device.port"
          >
            {{ deviceName[device.code] }}
          </md-option>
        </template>
      </md-select>
    </md-field>
    <div
      class="button"
      v-if="dongle && dongle.deviceList"
      @click="onPair"
      :disabled="!(dongle && device)"
    >
      {{ $t("loader.pair") }}
    </div>
    <div class="tip" v-if="dongle && dongle.isLatestVersion">
      {{ $t("loader.isLatestVersion") }}
    </div>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      :image="images['device_' + currentDevice.code]"
      @close="percent = -1"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      progressText: "",
      percent: -1,
      dongle: null,
      device: null,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      deviceName: "deviceName",
      currentDevice: "currentDevice",
    }),
    options() {
      return {
        speed: 400,
        mousewheel: true,
        effect: "coverflow",
        coverflowEffect: {
          depth: 300, // 深度
          rotate: -17, // 旋转角度
          scale: 1,
          stretch: -50, // 拉伸度
          slideShadows: false, // 是否显示滑动阴影
        },
      };
    },
  },
  methods: {
    onDongleUpdate() {
      if (this.dongle.isLatestVersion) return;
      this.$store.dispatch("loader/updateDongle", {
        dongle: {
          port: this.dongle.port,
        },
      });
    },
    onDeviceSelect(port) {
      const device = this.dongle.deviceList.find((i) => i.port === port);
      this.device = device;
    },
    onPair() {
      if (!(this.dongle && this.device)) return;
      this.$store.dispatch("loader/pairDongle", {
        dongle: this.dongle,
        device: this.device,
      });
    },
  },
  mounted() {
    this.$store.dispatch("loader/getDongle", {
      dongle: this.currentDevice,
    });

    window.setDongle = (json) => {
      if (json) {
        const data = JSON.parse(json);
        console.log("Bridge", "setDongle", data);
        this.dongle = data.dongle;
      }
    };

    window.updateDongleProgress = (json) => {
      console.log("Bridge", "updateDongleProgress", json);
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getDongle", {
            dongle: this.currentDevice,
          });
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };

    window.pairDongleProgress = (json) => {
      console.log("Bridge", "pairDongleProgress", json);
      if (json) {
        const data = JSON.parse(json);
        if (this.percent >= 100) {
          this.$message.info(
            this.isCN ? data.message.zh_CN : data.message.en_US
          );
          this.$store.dispatch("loader/getDongle", {
            dongle: this.currentDevice,
          });
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToPair"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };

    if (window.location.href.includes("localhost")) {
      setTimeout(() => {
        this.dongle = {
          port: "COM1",
          isLatestVersion: true,
          deviceList: [
            {
              code: "cb02",
              port: "COM3",
            },
            {
              code: "alice",
              port: "COM4",
            },
          ],
        };
        if (this.dongle.isLatestVersion) {
          this.progressText = this.$t("loader.isLatestVersion");
        }
      }, 2000);
    }
  },
};
</script>
<style lang="scss" scoped>
.dongle-list {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;

  .dongle {
    @include flex-center;
    font-size: 30px;
    margin-right: 15px;
    color: #ffffff;
    position: fixed;
    left: 130px;
    top: 40px;

    &.unlinked {
      color: $active-color;
    }

    .iconfont {
      font-size: 30px;
      margin-right: 5px;
    }
  }

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .version {
    @include flex-center;
    justify-content: space-between;
    width: 720px;
    padding: 10px 0;
    border-bottom: 3px solid #1d1d1d;
    font-size: 36px;
    margin-bottom: 50px;

    span {
      letter-spacing: 0;
    }

    .code {
      font-size: 28px;
      color: #3c3c3c;
      cursor: pointer;

      .iconfont {
        font-size: 28px;
      }
    }

    .new {
      width: 56px;
      vertical-align: text-top;
      margin-top: -10px;
    }
  }

  .device {
    width: 720px;
    margin-bottom: 50px;
  }

  .button {
    @include linear-button;
    width: 480px;
    height: 80px;
    line-height: 80px;
    margin-bottom: 40px;
  }

  .tip {
    height: 28px;
    line-height: 28px;
    font-size: 24px;
    text-align: center;
  }
}
</style>
<style lang="scss">
.dongle-list {
  .md-field.device {
    label {
      font-size: 36px;
      line-height: 50px;
    }

    .md-menu {
      height: 70px;

      .md-input {
        height: 70px;
        line-height: 70px;
        font-size: 36px;
      }
    }

    &.md-focused,
    &.md-has-value {
      label {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>
